var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.666656 8.66212L13.7238 8.66212L7.52853 14.8573C7.2656 15.115 7.26136 15.537 7.51901 15.8C7.77674 16.0629 8.19877 16.0672 8.4617 15.8095C8.46488 15.8064 8.46805 15.8032 8.47122 15.8L15.8044 8.46673C16.0649 8.20665 16.0653 7.78494 15.8052 7.52453C15.805 7.52428 15.8049 7.52412 15.8044 7.52412L8.47122 0.190898C8.20829 -0.0667477 7.78626 -0.0625153 7.52861 0.200419C7.27455 0.459612 7.27455 0.8744 7.52861 1.13359L13.7238 7.32881L0.666656 7.32881C0.298498 7.32881 0 7.62731 0 7.99547C0 8.36363 0.298498 8.66212 0.666656 8.66212Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2);
export default __webpack_public_path__ + "static/media/arrow_right_2.f29d34300c1934a67f18d108d56a2a71.svg";
export { ForwardRef as ReactComponent };